import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './FAQs.css';

const FAQs = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "What is LogCrest?",
      answer: "LogCrest is an AI-powered observability platform that provides comprehensive monitoring, analysis, and optimization for logs and infrastructure. Our platform helps organizations gain intelligent insights into their systems and resolve issues faster."
    },
    {
      id: 2,
      question: "How does LogCrest differ from other observability platforms?",
      answer: "LogCrest stands out with its AI-driven approach, eBPF-powered data collection, and real-time processing capabilities. We offer up to 10x cost reduction in log management while providing faster issue resolution and more accurate root cause analysis."
    },
    {
      id: 3,
      question: "What types of data sources can LogCrest integrate with?",
      answer: "LogCrest can integrate with various data sources including applications, containers, Kubernetes clusters, cloud infrastructure, databases, and custom applications. Our platform supports multiple log formats and provides seamless integration with existing tools."
    },
    {
      id: 4,
      question: "Is LogCrest suitable for small businesses?",
      answer: "Yes, LogCrest is designed to scale from small businesses to large enterprises. Our flexible pricing and scalable architecture make it suitable for organizations of all sizes, from startups to Fortune 500 companies."
    },
    {
      id: 5,
      question: "How does the AI-powered analysis work?",
      answer: "Our AI algorithms analyze log patterns, detect anomalies, and identify root causes automatically. The system learns from your infrastructure patterns and provides intelligent insights to help prevent issues before they impact your business."
    },
    {
      id: 6,
      question: "What is the setup process like?",
      answer: "Setting up LogCrest is straightforward. You can get started with our free trial, and our team provides comprehensive onboarding support. The platform can be deployed on-premises or in the cloud, depending on your requirements."
    },
    {
      id: 7,
      question: "How does LogCrest handle data security and privacy?",
      answer: "We take data security seriously. All data is encrypted in transit and at rest, and we comply with industry-standard security practices. We also offer on-premises deployment options for organizations with strict data residency requirements."
    },
    {
      id: 8,
      question: "What kind of support do you provide?",
      answer: "We offer comprehensive support including documentation, community forums, email support, and premium support options. Our team is available to help with setup, configuration, and troubleshooting."
    },
    {
      id: 9,
      question: "Can I try LogCrest before purchasing?",
      answer: "Yes, we offer a free trial that allows you to experience the full capabilities of our platform. You can start with a free trial and upgrade to a paid plan when you're ready."
    },
    {
      id: 10,
      question: "How does pricing work?",
      answer: "Our pricing is based on data volume and features. We offer flexible plans to suit different needs, from basic monitoring to enterprise-grade solutions. Contact our sales team for a customized quote based on your requirements."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="faqs-page">
      <div className="container">
        <motion.div
          className="faqs-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Frequently Asked Questions</h1>
          <p className="faqs-intro">
            Find answers to common questions about LogCrest's AI-powered observability platform.
          </p>
          
          <div className="faqs-list">
            {faqs.map((faq) => (
              <motion.div
                key={faq.id}
                className={`faq-item ${openFAQ === faq.id ? 'open' : ''}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: faq.id * 0.1 }}
              >
                <div 
                  className="faq-question"
                  onClick={() => toggleFAQ(faq.id)}
                >
                  <h3>{faq.question}</h3>
                  {openFAQ === faq.id ? <FiChevronUp /> : <FiChevronDown />}
                </div>
                <motion.div
                  className="faq-answer"
                  initial={false}
                  animate={{
                    height: openFAQ === faq.id ? 'auto' : 0,
                    opacity: openFAQ === faq.id ? 1 : 0
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <p>{faq.answer}</p>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FAQs;
